import iOsVersion from 'ios-version';

export const getiOSVersion = () => iOsVersion(navigator.userAgent);
export const isUnsupportediOSDevice = () => getiOSVersion() && getiOSVersion().major < 11;
